import {BboxStation} from '../../utils/model/BboxResult';
import {GMapInfo} from './GMapInfo';

interface Props {
    station: BboxStation;
    onStationClick: (station: BboxStation) => void;
    isCheapest: boolean;
    active: boolean;
}

const pinLegWidth = 18;
const pinLegHeight = 14;
const points = `0,0 ${pinLegWidth / 2},${pinLegHeight} ${pinLegWidth},0`;

const GMapMarker = ({station, onStationClick, isCheapest, active}: Props) => {
    const onClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onStationClick(station);
    }

    return (
        <div onClick={onClick} className={"marker"}>
            <svg height={pinLegHeight} width={pinLegWidth}>
                <polygon points={points}/>
            </svg>
            <div className="marker-inner">
                <GMapInfo
                    station={station}
                    isCheapest={isCheapest}
                    active={active}/>
            </div>
        </div>
    )
}

export default GMapMarker
